import {Component} from "@angular/core";
import {TabsPageContainer} from "../../../uiComponents/tabsPageContainer";

@Component({
	selector: 'outbound-report-tabs',
	templateUrl: './outbound-report-tabs.component.html',
})
export class OutboundReportTabsComponent extends TabsPageContainer {
}
